/* eslint-disable react/no-danger */
import React from "react";
import PropTypes from "prop-types";
// eslint-disable-next-line import/no-cycle
import { Link } from "../../sharedComponents/Link";
import { RichText } from "../../sharedComponents/RichText";
import { AlertComponent } from "./AlertComponent";
import * as styles from "./AlertComponent.module.scss";

const AlertComponentConnector = ({ data }) => (
	<div className={styles.alertComponentWrapper}>
		<AlertComponent
			heading={data?.displayTitle}
			variant={data?.alertVariant}
			dismissible={data?.dismissible}
			icon={data?.alertVariant}
			iconName={data?.iconName}>
			{data?.link && (
				<Link className={styles.alertComponentLink} to={data?.link?.url} target={data?.link.target}>
					<span className="sr-only">{data?.displayTitle}</span>
				</Link>
			)}
			{data?.content && <RichText data={data.content} LinkRenderComponent={Link} />}
		</AlertComponent>
	</div>
);

AlertComponentConnector.propTypes = {
	data: PropTypes.shape({
		content: PropTypes.object,
		link: PropTypes.shape({
			url: PropTypes.string,
			target: PropTypes.string,
		}),
		displayTitle: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
		alertVariant: PropTypes.oneOf(["success", "danger", "warning", "info", "none"]),
		dismissible: PropTypes.bool,
		iconName: PropTypes.string,
	}).isRequired,
};

export default AlertComponentConnector;
export { AlertComponentConnector };
